module.exports = __webpack_public_path__ + "static/media/talksCardBack.13780cdd.svg";